module.exports = __webpack_public_path__ + "img/0f39f91e8c13c0e5a128438ab5a336f2.0b431818.jpg";